export default "__VITE_ASSET__DzaX6u$U__"